import React from 'react';
import CardFront from './CardFront';
import CardBack from './CardBack';

/**
 * 下注卡片容器组件
 * 处理3D翻转逻辑和卡片交互
 */
export default function BettingCard({ 
  period, 
  data, 
  lastPrice, 
  amount, 
  isFlipped, 
  onCardClick, 
  onAmountChange, 
  onPredict 
}) {
  const handleClick = (e) => {
    // 只允许点击卡片空白区或正面内容区时翻转，阻止输入框/按钮等触发
    if (
      e.target.tagName === 'INPUT' ||
      e.target.tagName === 'BUTTON' ||
      e.target.closest('button') ||
      e.target.closest('input')
    ) {
      return;
    }
    onCardClick(period.minutes);
  };

  const handleAmountChange = (newAmount) => {
    onAmountChange(period.minutes, newAmount);
  };

  const handlePredict = (direction) => {
    onPredict(period.minutes, direction);
  };

  return (
    <div
      className="relative h-32 perspective-1000"
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      {/* 3D翻转容器 */}
      <div className={`
        relative w-full h-full transition-transform duration-700 transform-style-preserve-3d
        ${isFlipped ? 'rotate-y-180' : ''}
      `}>
        {/* 正面 - 信息展示 */}
        <CardFront period={period} data={data} />

        {/* 背面 - 下注操作 */}
        <CardBack 
          period={period}
          data={data}
          lastPrice={lastPrice}
          amount={amount}
          onAmountChange={handleAmountChange}
          onPredict={handlePredict}
        />
      </div>
    </div>
  );
}
